// src/app/services/mbrs/validation-control-type.util.ts

/** Minimal shape we need to classify a schema control's data type. */
export interface TypedControl {
  qname: string;
  type?: string;
  ui?: { controlType?: string; control?: string };
}

/**
 * True when a control holds a numeric/monetary value, so an empty cell may be
 * safely coerced to 0 for an equality comparison. Text and date controls must
 * NOT be coerced — an empty string or date is not "0".
 */
export function isNumericControl(control: TypedControl | undefined | null): boolean {
  if (!control) {
    return false;
  }
  if (control.type === 'MonetaryItemType') {
    return true;
  }
  if (control.ui?.controlType === 'number') {
    return true;
  }
  return false;
}
